var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-detail-actions"},[_c('div',{staticClass:"card-actions-container"},[_c('GoCommentsButton'),_c('GoDocumentsButton'),_c('GoHistoryButton')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }